"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/** https://material-ui.com/utils/popovers/#anchor-playground */
var anchorOrigin = {
  horizontal: 'center',
  vertical: 'center'
};
var transformOrigin = {
  horizontal: 'right',
  vertical: 'top'
};

var Menu = function Menu(_ref) {
  var Owner = _ref.Owner,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      onChangeOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      anchor = _useState4[0],
      onChangeAnchor = _useState4[1];

  var onClick = function onClick(_ref2) {
    var currentTarget = _ref2.currentTarget;
    onChangeOpen(!open);
    onChangeAnchor(currentTarget);
  };

  var onClose = function onClose() {
    onChangeOpen(false);
    onChangeAnchor(null);
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.ClickAwayListener, {
    onClickAway: onClose
  }, /*#__PURE__*/_react["default"].createElement(Owner, {
    "aria-owns": anchor && 'menu',
    "aria-haspopup": "true",
    onClick: onClick
  })), /*#__PURE__*/_react["default"].createElement(_core.Menu, {
    id: "menu",
    anchorEl: anchor,
    getContentAnchorEl: null,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    open: open,
    onClose: onClose
  }, children));
};

Menu.propTypes = {
  /** Render prop for the component this menu is attached to. */
  Owner: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired
};
var _default = Menu;
exports["default"] = _default;